<template>
  <div class="menu-list-page">
    <Header />
    <div class="menu-container">
      <!-- 左侧二级菜单 -->
      <aside class="menu-sidebar">
        <div class="sidebar-header">
          <h2 class="sidebar-title">{{ parentMenuName }}</h2>
        </div>
        <ul class="level2-list">
          <li
            v-for="item in level2Menu"
            :key="item.menuId"
            class="level2-item"
            :class="{ active: selectedLevel2?.menuId === item.menuId }"
            @click="selectLevel2(item)"
          >
            <!-- <span class="item-icon">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </span> -->
            <span class="item-name">{{ item.menuName }}</span>
          </li>
        </ul>
      </aside>

      <!-- 右侧三级菜单 -->
      <main class="menu-content">
       <!-- <div class="content-header">
          <h3 class="content-title">{{ selectedLevel2?.menuName || '请选择分类' }}</h3>
        </div> -->
        <div class="level3-grid" v-if="level3Menu.length > 0">
          <div
            v-for="item in level3Menu"
            :key="item.menuId"
            class="level3-card"
            @click="handleLevel3Click(item)"
          >
            <div class="card-icon">
              <img v-if="item.product?.imageUrl || item.image" :src="getFullImageUrl(item.product?.imageUrl || item.image)" class="icon-img" />
              <svg v-else viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="#4a90e2" stroke-width="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <path d="M9 12h6"/>
                <path d="M12 9v6"/>
              </svg>
            </div>
            <div class="card-info">
              <h4 class="card-title">{{ item.product?.productName || item.menuName }}</h4>
              <p class="card-desc" v-if="item.remark">{{ item.remark }}</p>
            </div>
           <!-- <span class="card-arrow">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </span> -->
            <button class="btn-booking-large" @click.stop="openBookingDialog(item)">立即预约</button>
			<div style="display: flex;justify-content: space-between;align-items: center;color: #9EA5AF;font-size: 12px;margin-top: 15px;">
				<div>
					已测试<span style="font-size: 16px;color: #C43230;"> {{item.product?.testCount || 0}} </span>次
				</div>
				<div>
					满意度 <span style="font-size: 16px;color: #C43230;"> {{item.product?.satisfactionRate || 0}} </span>
				</div>
			</div>
          </div>
        </div>
        <div class="empty-state" v-else>
          <svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="#ccc" stroke-width="1">
            <rect x="3" y="3" width="18" height="18" rx="2"/>
            <path d="M9 9h6"/>
            <path d="M9 12h6"/>
            <path d="M9 15h4"/>
          </svg>
          <p class="empty-text">暂无内容</p>
        </div>
      </main>
    </div>
    <Footer />

    <!-- 预约弹框 -->
    <BookingDialog
      v-model:visible="bookingDialogVisible"
      :product="currentBookingItem"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getProductDetail, getProducts } from '@/api/product'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import BookingDialog from '@/components/BookingDialog.vue'
import { treeWithProduct } from '@/api/website'
// import { ElMessage } from 'element-plus'
const route = useRoute()
const router = useRouter()
const BASE_URL = process.env.VUE_APP_BASE_URL || ''
const menuTree = ref([])
const parentMenuId = ref(null)
const parentMenuName = ref('')
const selectedLevel2 = ref(null)
const bookingDialogVisible = ref(false)
const currentBookingItem = ref(null)
const product = ref([])

const getFullImageUrl = (url) => {
	console.log(url)
  if (!url) return ''
  if (url.startsWith('http')) return url
  return BASE_URL + encodeURI(url)
}
// 二级菜单列表
const level2Menu = computed(() => {
  const parent = menuTree.value.find(m => m.menuId === parentMenuId.value)
  return parent?.children || []
})

// 三级菜单列表（如果没有三级，则显示二级本身）
const level3Menu = computed(() => {
  if (!selectedLevel2.value) return []
  // 如果有三级菜单，显示三级
  if (selectedLevel2.value.children && selectedLevel2.value.children.length > 0) {
    return selectedLevel2.value.children
  }
  // 如果没有三级菜单，返回二级菜单本身（作为可点击项）
  return [selectedLevel2.value]
})

// 是否是二级菜单本身（没有三级的情况）
const isLevel2Item = computed(() => {
  if (!selectedLevel2.value) return false
  return !selectedLevel2.value.children || selectedLevel2.value.children.length === 0
})

// 选择二级菜单
const selectLevel2 = (item) => {
  selectedLevel2.value = item
}

// 打开预约弹框
const openBookingDialog = (item) => {
  // currentBookingItem.value = item
  
  loadProductDetail(item.productId)
}
const loadProductDetail = async (productId) => {
  try {
	// const productId= url.split('/product/')[1];
    const res = await getProductDetail(productId)
    if (res.code === 200 && res.data) {
      currentBookingItem.value = res.data
	  bookingDialogVisible.value = true
    }else{
		alert('接口报错')
	}
  } catch (error) {
    console.error('加载产品详情失败:', error)
  }
}

// 点击三级菜单（或没有三级时的二级菜单）
const handleLevel3Click = (item) => {
  if (item.url) {
    // 如果是二级菜单本身（没有三级的情况）
    if (isLevel2Item.value) {
      const path = [
        { menuId: parentMenuId.value, menuName: parentMenuName.value },
        { menuId: item.menuId, menuName: item.menuName, url: item.url }
      ]
      // 直接使用 url 作为路径
      const targetPath = item.url.startsWith('/') ? item.url : '/' + item.url
      router.push({
        path: targetPath,
        query: { menuPath: JSON.stringify(path) }
      })
    } else {
      // 正常的三级菜单
      const path = [
        { menuId: parentMenuId.value, menuName: parentMenuName.value },
        { menuId: selectedLevel2.value.menuId, menuName: selectedLevel2.value.menuName },
        { menuId: item.menuId, menuName: item.menuName, url: item.url }
      ]
      // 直接使用 url 作为路径
      const targetPath = item.url.startsWith('/') ? item.url : '/' + item.url
      router.push({
        path: targetPath,
        query: { menuPath: JSON.stringify(path) }
      })
    }
  }
}

// 加载菜单数据
const loadData = async () => {
  try {
    const res = await treeWithProduct()
    if (res.code === 200 && res.data) {
      menuTree.value = res.data
      // 从路由参数获取父菜单ID
      const menuId = parseInt(route.query.menuId)
      const level2Id = parseInt(route.query.level2Id)
      if (menuId) {
        const parent = menuTree.value.find(m => m.menuId === menuId)
        if (parent) {
          parentMenuId.value = menuId
          parentMenuName.value = parent.menuName
          // 如果有指定二级菜单ID，选中它；否则选中第一个
          if (parent.children && parent.children.length > 0) {
            if (level2Id) {
              const targetLevel2 = parent.children.find(c => c.menuId === level2Id)
              selectedLevel2.value = targetLevel2 || parent.children[0]
            } else {
              selectedLevel2.value = parent.children[0]
            }
          }
        }
      }
    }
  } catch (error) {
    console.error('加载菜单失败:', error)
  }
}

// 监听路由变化
watch(() => route.query, (newQuery) => {
  const menuId = parseInt(newQuery.menuId)
  const level2Id = parseInt(newQuery.level2Id)
  if (menuId && menuId !== parentMenuId.value) {
    const parent = menuTree.value.find(m => m.menuId === menuId)
    if (parent) {
      parentMenuId.value = menuId
      parentMenuName.value = parent.menuName
      if (parent.children && parent.children.length > 0) {
        if (level2Id) {
          const targetLevel2 = parent.children.find(c => c.menuId === level2Id)
          selectedLevel2.value = targetLevel2 || parent.children[0]
        } else {
          selectedLevel2.value = parent.children[0]
        }
      }
    }
  } else if (level2Id && parentMenuId.value) {
    // 只切换二级菜单
    const parent = menuTree.value.find(m => m.menuId === parentMenuId.value)
    if (parent && parent.children) {
      const targetLevel2 = parent.children.find(c => c.menuId === level2Id)
      if (targetLevel2) {
        selectedLevel2.value = targetLevel2
      }
    }
  }
}, { deep: true })

onMounted(() => {
  loadData()
})
</script>

<style scoped>
.menu-list-page {
  min-height: 100vh;
  background: #f5f7fa;
}

.menu-container {
  display: flex;
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 100px;
  min-height: calc(100vh - 100px);
}

/* 左侧边栏 */
.menu-sidebar {
  width: 280px;
  background: #fff;
  border-right: 1px solid #e8e8e8;
  flex-shrink: 0;
}

.sidebar-header {
  padding: 24px 20px;
  border-bottom: 1px solid #e8e8e8;
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
}

.sidebar-title {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}

.level2-list {
  list-style: none;
  padding: 12px 0;
  margin: 0;
}

.level2-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.2s;
  border-left: 3px solid transparent;
  color: #333;
}

.level2-item:hover {
  background: #f5f7fa;
  color: #4a90e2;
}

.level2-item.active {
  background: #e8f4fd;
  border-left-color: #4a90e2;
  color: #4a90e2;
}

.level2-item .item-icon {
  display: flex;
  align-items: center;
  margin-right: 12px;
  opacity: 0.6;
  transition: all 0.2s;
}

.level2-item.active .item-icon,
.level2-item:hover .item-icon {
  opacity: 1;
}

.level2-item .item-name {
  font-size: 15px;
  font-weight: 500;
}

/* 右侧内容区 */
.menu-content {
  flex: 1;
  padding: 30px 40px;
  background: #f5f7fa;
}

.content-header {
  margin-bottom: 24px;
}

.content-title {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0;
  padding-bottom: 16px;
  border-bottom: 2px solid #4a90e2;
  display: inline-block;
}

/* 三级菜单网格 */
.level3-grid {
 /* display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px; */
  display: flex;
  flex-wrap: wrap;
}

.level3-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e8e8e8;
  width: 245px;
  margin-right: 15px;
  margin-bottom: 15px;
}

.level3-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(74, 144, 226, 0.15);
  border-color: #4a90e2;
}

.card-icon {
  width: 120px;
  height: 120px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.icon-img {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 12px;
}

.card-info {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 16px;
  /* font-weight: 600; */
  color: #333;
  margin: 0 0 6px 0;
  margin: 15px auto;
  text-align: center;
  white-space: nowrap;      
  overflow: hidden;         
  text-overflow: ellipsis;
}

.card-desc {
  font-size: 13px;
  color: #999;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-arrow {
  color: #ccc;
  transition: all 0.2s;
}

.level3-card:hover .card-arrow {
  color: #4a90e2;
  transform: translateX(4px);
}

.btn-booking-large {
  /* padding: 8px 20px; */
  width: 100%;
  height: 34px;
  line-height: 34px;
  border:1px solid #C43230;
  border-radius: 4px;
  background-color: #fff;
  color: #C43230;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-booking-large:hover {
  background: #fff;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
}

.empty-text {
  margin-top: 16px;
  font-size: 14px;
  color: #999;
}
</style>
